// import main1 from '../assets/img/main/headerMain_01.jpg';
// import main2 from '../assets/img/main/headerMain_02.jpg';
// import main3 from '../assets/img/main/headerMain_03.jpg';
import bgInner01 from '../assets/img/company.jpeg';
import bgInner02 from '../assets/img/survey.jpeg';
import bgInner03 from '../assets/img/bizz.jpeg';
import bgInner04 from '../assets/img/perf.jpeg';
import bgInner05 from '../assets/img/cust.jpeg';

export default function HeaderInner ({ id }) {
  let bgData = null;
  switch (id) {
    case '1':
      bgData = bgInner01;
      break;
    case '2':
      bgData = bgInner02;
      break;
    case '3':
      bgData = bgInner03;
      break;
    case '4':
      bgData = bgInner04;
      break;
    case '5':
      bgData = bgInner05;
      break;
  }
  return (
      <section id="hero-inner"  style={{backgroundImage: `url(${bgData})`}} className="d-flex align-items-center">
        <div className="container position-relative" data-aos="fade-up" data-aos-delay="500">
          <h1>주식회사 공간지적측량</h1>
          {/* <a href="#about" className="btn-get-started scrollto">Get Started</a> */}
        </div>
      </section>
  );
}